import _ from 'lodash';
import NavigationStep from './NavigationStep';

function NavigationData(data, translator) {
    if (data) {
        this.firstSteps = _.map(data.firstSteps, (aStep) => {
            return new NavigationStep(aStep, translator);
        });

        this.dynamicSteps = _.map(data.dynamicSteps, (aStep) => {
            return new NavigationStep(aStep, translator);
        });

        this.lastSteps = _.map(data.lastSteps, (aStep) => {
            return new NavigationStep(aStep, translator);
        });

        _.extend(this, data);
    } else {
        this.firstSteps = [];
        this.dynamicSteps = [];
        this.lastSteps = [];

        this.jobNumber = '';
        this.accountNumber = '';
        this.effectiveDate = '';
    }
}

export default NavigationData;